import React, { useEffect, useState } from 'react';
import api from '../api';
import "../css/modern-dashboard.css";

const makeKey = (length) => {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * characters.length));
  }
  return result;
};

const AdminDashboard = ({changePage}) => {
  const [hosts, setHosts] = useState([]);

  useEffect(() => {
    api.get('/getAPIinfo')
      .then(response => {
        if(response.status == 200) {
          setHosts(response.data.apiKeys);
        }
        else {
          changePage('tryAdmin');
        }
      })
      .catch(error => {
        console.error('Error fetching API info:', error);
      });
  }, []);

  const handleChange = (index, field, value) => {
    const updatedHosts = [...hosts];
    updatedHosts[index][field] = value;
    setHosts(updatedHosts);

    api.post('/setAPIinfo', updatedHosts[index])
      .then(res => {
        if (res.data !== 'success') {
          changePage('tryAdmin')
        }
      });
  };

  const handleRefreshKey = (index) => {
    const updatedHosts = [...hosts];
    updatedHosts[index].apiKey = makeKey(10);
    setHosts(updatedHosts);
  };

  return (
    <div className="modern-dashboard admin-dashboard">
      <div className="modern-container">
        <div className="wrap-container">
          {/* Admin Header */}
          <div className="admin-header">
            <div className="admin-title-section">
              <h1 className="admin-title">
                <i className="fas fa-shield-alt me-3"></i>
                관리자 대시보드
              </h1>
              <p className="admin-subtitle">API 키 및 호스트 관리</p>
            </div>
            <button 
              className="back-to-main-btn"
              onClick={() => changePage('main')}
            >
              <i className="fas fa-arrow-left me-2"></i>
              메인으로 돌아가기
            </button>
          </div>

          {/* Admin Content */}
          <div className="modern-card admin-content-card">
            <div className="card-header">
              <h4 className="card-title">
                <i className="fas fa-key me-2"></i>
                API 키 관리
              </h4>
              <span className="host-stats">
                총 {hosts.length}개 호스트 · {hosts.filter(h => h.enabled).length}개 활성화
              </span>
            </div>
            
            <div className="card-body">
              <div className="admin-hosts-grid">
                {hosts.map((host, index) => (
                  <div key={index} className={`admin-host-card ${host.enabled ? 'enabled' : 'disabled'}`}>
                    <div className="host-card-header">
                      <div className="host-info-section">
                        <h3 className="host-name">
                          <i className="fas fa-desktop me-2"></i>
                          {host.username}
                        </h3>
                        <div className="host-status-badge">
                          <span className={`status-dot ${host.enabled ? 'active' : 'inactive'}`}></span>
                          {host.enabled ? '활성화' : '비활성화'}
                        </div>
                      </div>
                      
                      <div className="host-toggle">
                        <label className="modern-switch">
                          <input
                            type="checkbox"
                            checked={host.enabled}
                            onChange={(e) => handleChange(index, 'enabled', e.target.checked)}
                          />
                          <span className="switch-slider"></span>
                        </label>
                      </div>
                    </div>
                    
                    <div className="api-key-section">
                      <label className="api-key-label">API 키</label>
                      <div className="api-key-container">
                        <div className="api-key-display">
                          <code className="api-key-code">{host.apiKey}</code>
                        </div>
                        <button
                          className="refresh-key-btn"
                          onClick={() => handleRefreshKey(index)}
                          title="API 키 새로고침"
                        >
                          <i className="fas fa-sync-alt"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              
              {hosts.length === 0 && (
                <div className="empty-state">
                  <i className="fas fa-server empty-icon"></i>
                  <h3>호스트가 없습니다</h3>
                  <p>아직 등록된 호스트가 없습니다.</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
